Apt.fn.extend('maps', {}, {
	/**
	 * Add instance layer
	 *
	 * @param {Object} config
	 * @param {String} [before]
	 */
	addLayer(config, before) {
		const scope = this;

		if (scope.map.getLayer(config.id)) {
			return;
		}

		scope.map.addLayer(config, before);

		scope.instance.layers[config.id] = [config, before];
	},

	/**
	 * Remove instance layer
	 *
	 * @param {String} [id]
	 */
	removeLayer(id) {
		const scope = this;
		const instance = scope.instance;

		if (id) {
			if (instance.layers[id]) {
				scope.map.removeLayer(id);

				delete instance.layers[id];
			}

			return;
		}

		Object.keys(instance.layers).forEach(id => {
			scope.map.removeLayer(id);
		});

		instance.layers = [];
	}
});